import apiAccessModalStyle from './api-access-modal.module.css';

import React from 'react';
import { useTranslation } from 'react-i18next';

import Input from '../../../../components/Input';
import Button from '../../../../components/Button';
import MessageBox from '../../../../components/MessageBox';
import ModalContainer from '../../../../components/ModalContainer';

const ApiKeyInfoModal = ({
  isOpenDownloadModal,
  messages,
  messageKeyPrefix,
  setMessages,
  modalApiKeyName,
  modalGetApiKey,
  onCloseModal,
  onClickModalDownloadApiKey,
}) => {
  const { t } = useTranslation();

  return (
    <ModalContainer
      modalWidthType="modal-500px"
      openModal={isOpenDownloadModal}
      closeModal={() => onCloseModal('download')}
    >
      <div className="header">
        {/* Generate API key */}
        <div className="title">{t('608c815be4')}</div>
      </div>
      <div className="body">
        <MessageBox
          show={!!messages.generateModalDanger}
          label={t(`${messageKeyPrefix.e.s}${messages.generateModalDanger}`)}
          variant="danger"
          onClose={() =>
            setMessages({ ...messages, generateModalDanger: null })
          }
        />

        {/* API key name */}
        <div className="modal-form-title required">{t('1a1d8746f6')}</div>
        <div className="modal-form-field">
          <Input
            type="text"
            placeholder={t('7563cde047')}
            value={modalApiKeyName}
            autoComplete="new-email1"
            disabled
          />
          <div className="modal-form-title mb-3">{t('43c4b7111c')}</div>
          <div className={apiAccessModalStyle['modal-api-key-area']}>
            <div className="mb-5">{modalGetApiKey}</div>
            <span className={apiAccessModalStyle['modal-api-key-note-title']}>
              {t('caf8daf83b')}
            </span>
          </div>
          <div>{t('2791e3d37e')}</div>
        </div>
      </div>
      <div className="footer non-border-top-footer">
        {/* Download API key */}
        <Button
          label={t('fd29fc2e26')}
          className="btn-submit"
          onClick={() => onClickModalDownloadApiKey()}
          disabled={modalGetApiKey === ''}
        />
      </div>
    </ModalContainer>
  );
};

export default React.memo(ApiKeyInfoModal);
